import {
  GET_YUSA_OVERNIGHT_CAMP_OVERVIEW_DETAILS,
  GET_BRACH_YEAR_WISE_REPORT
} from '@config/api-config';
import { asyncRequest } from '@config/http-config';
import * as types from './types';

// eslint-disable-next-line import/prefer-default-export
export const getOvernightCampDataOverview =
  (branchNumber, reportBatchId, year) => (dispatch, getState) =>
    asyncRequest({
      url: GET_YUSA_OVERNIGHT_CAMP_OVERVIEW_DETAILS(
        branchNumber,
        reportBatchId,
        year
      ),
      successAction: data => ({
        type: types.YUSA_OVERNIGHT_CAMP_GET_OVERVIEW_SUCCESS,
        async: true,
        payload: data,
        state: getState()
      }),
      failureAction: error => ({
        type: types.YUSA_OVERNIGHT_CAMP_GET_OVERVIEW_FAILURE,
        payload: error
      }),
      dispatch
    });

export const getCampReportsDashboardOverviewData =
  (AssociationId, Year) => (dispatch, getState) =>
    asyncRequest({
      url: GET_BRACH_YEAR_WISE_REPORT(AssociationId, Year),
      successAction: data => ({
        type: types.GET_BRACH_YEAR_WISE_REPORT_SUCCESS,
        async: true,
        payload: data,
        state: getState()
      }),
      failureAction: error => ({
        type: types.GET_BRACH_YEAR_WISE_REPORT_FAILURE,
        payload: error
      }),
      dispatch
    });
